export const MemberTagsVisibleInMemberList = ({ memberTags }) =>
  memberTags.filter(memberTag => {
    const displayLocations = memberTag.display_locations || {};
    return displayLocations.member_directory && memberTag.is_public;
  });
